module.exports = __webpack_public_path__ + "img/SE5164048992.caca8b4f.png";